import { createApp, h } from 'vue';

import errorHandler from 'Utils/errorHandler.js';

import JobOpenings from './components/JobOpenings.vue';

/* Global store */
import store from './store.js';
import { loadPostings, setFilter } from './helpers/postings.js';

const root = document.querySelector('#job-openings');
const dataElement = document.querySelector('#job-openings-data');

if (root && dataElement) {
	try {
		const postings = JSON.parse(dataElement.textContent);
		loadPostings(store, postings);

		/* Honour existing department hash links as an initial department filter */
		const hash = decodeURIComponent(window.location.hash.replace(/^#/, ''));
		if (hash && store.departments[hash]) {
			setFilter(store, hash, 'departments');
		}

		const app = createApp({
			render: () => h(JobOpenings, {
				talentCommunityUrl: root.dataset.talentCommunityUrl,
			}),
		});
		app.config.globalProperties.$store = store;
		app.mount(root);
	} catch (error) {
		errorHandler(error);
	}
}
